import NavBar from '../NavBar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { Link } from '@mui/material'
import Button from '../shared/Button'

const AddNewOrgWithFormLink = () => {
  return (
    <section
      id="add-new-organization"
      className="bg-white min-h-screen flex flex-col px-8"
    >
      <NavBar theme="dark" />
      <div className="relative flex flex-grow p-8 flex-col gap-8 max-w-[964px] m-auto">
        <h2 className="uppercase font-decimal text-[26px] text-green leading-[32px] font-bold">
          REQUEST INCLUSION OF YOUR ORGANIZATION, WORK, OR INITIATIVE ON THE
          MAP.
        </h2>
        <p className="text-[18px] text-black font-decimal font-normal">
          Organizations and initiatives included on the map are diverse in
          target liable institution, focus area and more, but share a common
          goal of being engaged in work to advance reparations for Black people
          in the United States.
        </p>
        <p className="text-[18px] text-black font-decimal font-normal mt-1">
          Please complete and submit the form below to have your work considered
          for inclusion. Information submitted on this form will be viewable in
          the map and in a table found on this site, unless otherwise noted
          below. Please do not submit confidential or private information not
          intended for public view. Please only submit information about
          organizations you represent.
        </p>
        <p className="text-[18px] text-black font-decimal font-normal mt-1">
          For additional questions about the map, please reach out to us at{' '}
          <a
            className="text-green font-semibold"
            href="mailto:map@firstrepair.org"
          >
            map@firstrepair.org
          </a>
          .
        </p>
        <Button
          styles={{ marginRight: 'auto' }}
          onClick={() => {
            window.open(
              'https://forms.gle/W7kAeXVaNzFsH25w7',
              '_blank',
              'noopener,noreferrer'
            )
          }}
        >
          <FontAwesomeIcon icon={faPlus} />
          <p className="text-[16px] uppercase font-bold pr-4">
            Organization or Initiative
          </p>
          <FontAwesomeIcon icon={faArrowRight} />
        </Button>
      </div>
    </section>
  )
}

export default AddNewOrgWithFormLink
